import { getCId, useDebouncedEffect } from '@coverright/utils';
import {
  useCreatePdpQuoteForClientMutation,
  useSavePdpQuoteMutation,
} from '..';
import * as Apollo from '@apollo/client';

type Quote = { clientId: string; zip?: string | null; county?: string | null; id?: string | null };

export function useCreatePdpQuoteIfNotExists(
  isAdmin: boolean,
  quote?: Quote,
  pdpQuoteId?: string,
  baseOptions?: Apollo.MutationHookOptions<any, any>
) {
  const [createQuoteAsAdmin] = useCreatePdpQuoteForClientMutation(baseOptions);
  const [createQuoteAsClient] = useSavePdpQuoteMutation(baseOptions);

  const createQuote = isAdmin ? createQuoteAsAdmin : createQuoteAsClient;

  useDebouncedEffect(
    () => {
      if (quote?.id && !pdpQuoteId) {
        createQuote({
          variables: {
            input: {
              cId: getCId(),
              insulinSavings: false,
              countyName: quote.county,
              zip: quote.zip,
              medicareQuoteId: isAdmin ? undefined : quote.id,
              clientId: isAdmin ? quote.clientId : undefined,
            },
          },
        }).catch(err => {
          // Backend sometimes returns null for this non-nullable field instead of a GraphQL error;
          // catch here so it surfaces as a normal Apollo error instead of an unhandled rejection.
          console.error('Failed to auto-create PDP quote', err);
        });
      }
    },
    600,
    [quote, pdpQuoteId, createQuote, isAdmin]
  );
}
